<template>
    <v-dialog
        :value="isOpen"
        max-width="700px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Skanowanie kodów EAN
                </h1>
            </v-card-title>
            <v-card-text>
                <v-alert
                    v-if="referentialPattern"
                    class="mb-0"
                    icon="mdi-barcode-scan"
                    prominent
                    text
                    type="success"
                >
                    <h3 class="text-center">
                        Zeskanowany wzór - <b>{{ referentialPattern.referentialPattern }}</b>
                    </h3>
                    <v-divider class="my-4 success" />
                    <v-icon color="success" class="mr-2">
                        mdi-information-outline
                    </v-icon>
                    Zeskanuj kod produktu
                </v-alert>
                <v-alert
                    v-if="!referentialPattern"
                    class="mb-0"
                    icon="mdi-barcode-scan"
                    prominent
                    text
                    type="info"
                >
                    Zeskanuj kod wzoru
                </v-alert>
                <v-row v-if="referentialPattern">
                    <v-col cols="12">
                        <v-data-table
                            :items="eanCodeList"
                            hide-default-header
                            :mobile-breakpoint="0"
                            :items-per-page="10"
                            name="EanCodeList"
                        >
                            <template #item="{item}">
                                <tr :class="{'red-row': !item.isCompliant && isFirstItemInTable(item)}">
                                    <td>
                                        <span class="pr-3">Czy kod jest zgodny</span>
                                        <v-icon :color="item.isCompliant ? 'green' : 'red'">
                                            {{ item.isCompliant ? 'mdi-check' : 'mdi-close' }}
                                        </v-icon>
                                    </td>
                                    <td>{{ item.pattern }}</td>
                                    <td>{{ item.amount }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="primary"
                    class="ma-2"
                    :disabled="!referentialPattern"
                    data-sentry-label="Kolejny wzór"
                    @click="nextScan"
                >
                    Kolejny wzór
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    class="ma-2"
                    :loading="actionLoading"
                    data-sentry-label="Zakończ"
                    @click="onClose"
                >
                    Zakończ
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import EANCodeScanner from '@/mixins/EANCodeScanner'

export default {
    name: 'ControlCodeDialog',
    mixins: [EANCodeScanner],
    props: {
        reportId: {
            type: Number,
            required: true,
        },
        orderNumber: {
            type: String,
            required: true,
        },
        isOpen: {
            type: Boolean
        },
    },
    data() {
        return {
            referentialPattern: null,
            actionLoading: false,
            eanCodeList: [],
        }
    },
    watch: {
        isOpen(val) {
            if (val) {
                this.listenForEANCodeScanner(this.handleEANCode)
            } else {
                this.stopListenForEANCodeScanner()
            }
        }
    },
    methods: {
        handleEANCode(code) {
            if (!this.referentialPattern) {
                this.codeComplianceStart(code)
            } else {
                this.codeCompliancePatternAdd(code)
            }
        },
        codeComplianceStart(code) {
            this.$store.dispatch('reports/createCompliance', {
                reportId: this.reportId,
                orderNumber: this.orderNumber,
                referentialPattern: code,
            })
                .then(({data}) => {
                    this.referentialPattern = data
                })
        },
        codeCompliancePatternAdd(code) {
            this.$store.dispatch('reports/addCompliancePattern', {
                codeComplianceId: this.referentialPattern.id,
                pattern: code,
            })
                .then(({data}) => {
                    this.eanCodeList = data.codeCompliance.codeCompliancePatternsAggregated
                })
        },
        nextScan() {
            this.referentialPattern = null
            this.eanCodeList = []
            this.$emit('on-next-scan')
        },
        onClose() {
            this.referentialPattern = null
            this.eanCodeList = []
            this.$emit('on-close')
        },
        isFirstItemInTable(item) { 
            return this.eanCodeList[0]['pattern'] === item['pattern']
        }
    }
}
</script>